import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import axios from 'axios';

import { useCraftProp } from '@/components/builder/utils';
import config from '@/config';

import SelectProperty from './Select';

export default function SelectClassesProperty(props) {
  const [isLoadedConfig, setIsLoadedConfig] = useState(false)
  const { value: defaultOptions, setValue: setOptions } = useCraftProp(`${props.name}-options`)

  const { id } = useParams()

  const handleChange = item => {
    setOptions(item)
  }

  const fetchOptions = useCallback(async value => {
    if (!isLoadedConfig) {
      await axios.post(`${config.tailwindProcessor}/config/${id}`, {
        tailwindConfig: "",
      })
    }

    const { data: { hasDesignSystem, classes } } = await axios.get(`${config.tailwindProcessor}/suggestions/${id}`, {
      params: {
        className: value,
      },
    })
    setIsLoadedConfig(hasDesignSystem)

    return classes
  }, [id, isLoadedConfig])

  const loadOptions = useCallback(async value => {
    if (!value) return { options: defaultOptions || [] }

    const options = await fetchOptions(value)

    return { options: [...options, ...defaultOptions || []] }
  }, [defaultOptions, fetchOptions])

  return <SelectProperty {...props}
    loadOptions={loadOptions}
    onChange={handleChange}
    async
    creatable
    asyncOnType
    variant='accent'
  />
}
